import script from "./DomainModelUpdatedProjection.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelUpdatedProjection.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelUpdatedProjection.vue?vue&type=style&index=0&id=7198ecce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7198ecce"]])

export default __exports__